import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import type { DeviceKind } from '../../../camera/types';
import type { CameraSide } from '../../../camera/utils/get-camera-options';
type PreviewProps = {
  imageSrc: string;
  onRetake: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  cameraKind: CameraSide;
  deviceKind: DeviceKind;
  title?: string;
};
const Preview = t0 => {
  const $ = _c(34);
  const {
    imageSrc,
    onRetake,
    onConfirm,
    isLoading,
    cameraKind,
    deviceKind,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.photo-capture.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== title) {
    t2 = title && <p className="text-label-1 text-primary text-center mb-4">{title}</p>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = title ? "max-h-[180px] w-auto mx-auto" : "w-full";
  const t4 = cameraKind === "front" && "-scale-x-100";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = cx("rounded", t3, t4);
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t(_temp);
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== cameraKind || $[9] !== deviceKind || $[10] !== imageSrc || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex items-start justify-center w-full"><img data-dd-privacy="mask" src={imageSrc} data-camera-kind={cameraKind} data-device-kind={deviceKind} className={t5} alt={t6} /></div>;
    $[8] = cameraKind;
    $[9] = deviceKind;
    $[10] = imageSrc;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp2);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isLoading || $[17] !== onConfirm || $[18] !== t8) {
    t9 = <Button fullWidth={true} onClick={onConfirm} variant="primary" loading={isLoading} disabled={isLoading} size="large">{t8}</Button>;
    $[16] = isLoading;
    $[17] = onConfirm;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp3);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isLoading || $[23] !== onRetake || $[24] !== t10) {
    t11 = <Button fullWidth={true} onClick={onRetake} variant="secondary" disabled={isLoading} size="large">{t10}</Button>;
    $[22] = isLoading;
    $[23] = onRetake;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== deviceKind || $[27] !== t11 || $[28] !== t9) {
    t12 = <div className="flex justify-center items-center flex-col w-full gap-y-2 mt-4" data-device-kind={deviceKind}>{t9}{t11}</div>;
    $[26] = deviceKind;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t2 || $[32] !== t7) {
    t13 = <div className="flex items-center flex-col justify-center w-full">{t2}{t7}{t12}</div>;
    $[30] = t12;
    $[31] = t2;
    $[32] = t7;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default Preview;
function _temp($) {
  return $["image-alt"];
}
function _temp2($_0) {
  return $_0.confirm;
}
function _temp3($_1) {
  return $_1.retake;
}